import _ from 'lodash'

const lodashChunk: (array: any, size?: number, guard?: unknown) => any[] = _.chunk

export function chunk(array: any[], size?: number, guard?: unknown): any[] {
  return lodashChunk(array, size, guard)
}

export function compact(array: any[]): any[] {
  return _.compact(array)
}

export function concat(array: any, ...values: any[]): any[] {
  return _.concat(array, ...values)
}

export function difference(array: any[], values: any[]): any[] {
  return _.difference(array, values)
}

const lodashDrop: (array: any, n?: number, guard?: unknown) => any[] = _.drop

export function drop(array: any[], n?: number, guard?: unknown): any[] {
  return lodashDrop(array, n, guard)
}

export function fill(array: any[], value: any, start?: number, end?: number): any[] {
  return _.fill(array, value, start, end)
}

export function first(array: any[]): any[] {
  return _.first(array)
}

export function flatten(array: any[]): any[] {
  return _.flatten(array)
}

export function flattenDeep(array: any[]): any[] {
  return _.flattenDeep(array)
}

export function head(array: any[]): any[] {
  return _.head(array)
}

export function initial(array: any[]): any[] {
  return _.initial(array)
}

export function intersection(...params: any[]): any[] {
  return _.intersection.apply(null, params)
}

export function join(array: any[], separator: string): string {
    return _.join(array, separator)
}

export function joinStr(...params: any[]): string {
  const array = _.initial(params)
  const separator = _.last(params)
  return array.join(separator)
}

export function last(array: any[]): any {
  return _.last(array)
}

export function nth(array: any[], n?: number): any {
  return _.nth(array, n)
}

export function reverse(array: any[]): any[] {
  return _.reverse(array)
}

export function slice(array: any[], start?: number, end?: number): any[] {
  return _.slice(array, start, end)
}

export function tail(array: any[]): any[] {
  return _.tail(array)
}

const lodashTake: (array: any, n?: number, guard?: unknown) => any[] = _.take

export function take(array: any[], n?: number, guard?: unknown): any[] {
  return lodashTake(array, n, guard)
}

const lodashTakeRight: (array: any, n?: number, guard?: unknown) => any[] = _.takeRight

export function takeRight(array: any[], n?: number, guard?: unknown): any[] {
  return lodashTakeRight(array, n, guard)
}

export function union(...params: any[]): any[] {
  return _.union.apply(null, params)
}

export function uniq(array: any[]): any[] {
  return _.uniq(array)
}

export function uniqBy(array: any[], iteratee: any): any[] {
  return _.uniqBy(array, iteratee)
}

export function unzip(array: any[]): any[] {
  return _.unzip(array)
}

export function without(array: any[], ...values: any[]): any[] {
  return _.without(array, ...values)
}

export function xor(...params: any[]): any[] {
  return _.xor.apply(null, params)
}

export function zip(...params: any[]): any[] {
  return _.zip.apply(null, params)
}

